<template>

<div>

<!-- <div class="toploginHeader pt-2 pb-2">

<a class="mt-2 mb-2" href="http://sinaiuniversity.net/"><img
                                    src="./../assets/logo-white2.png" alt="" width="180" 
                                     title="logo 2" >
                                     </a>

</div> -->

  <div class="container">

<!-- modal -->
     <b-modal id="modal-lg" size="lg" title="Login">


          <div class="panal-modal">
            <div>

              <div class="panal-header-modal"> {{ info.PageName ? info.PageName : '' }}</div>
              <div class="panal-body-modal">

                <div v-html="info.PageDescription"></div>
              </div>
            </div>



          </div>

          <div class="panal-modal" v-for="help in info.HelpSection" :key="help.serial">
            <div>

              <div class="panal-header-modal"> {{ help.SectionName }}</div>
              <div class="panal-body-modal">

                <div v-html="help.SectionDescription"></div>
              </div>
            </div>



          </div>







        </b-modal>
    

    <div class="row ">
      <div class="align-items-center w-100 text-white ">
        <h1 class="align-items-center mt-40" align="center"><br/>Welcome</h1>
        <p class="align-items-center" align="center">
          </p>
      </div>
    
    

      <div class="col-md-4 mx-auto mb-70">
        <div class="panal card-container">
          <div class="panal-header"><span>Login</span> <span class="pull-right">
            <!-- <b-button v-b-modal.modal-lg v-b-tooltip.hover title="Help" class="info">
          <font-awesome-icon icon="info" />
        </b-button> -->
        </span></div>

          <div class="col-md-9 mx-auto ">
                    <form name="form" @submit.prevent="handleLogin">
                      <div class="form-group mt-40">

                        <div class="input-group">
                          <div class="input-group-prepend">
                            <div class="input-group-text">
                              <font-awesome-icon icon="user" />
                            </div>
                          </div>
                          <input v-model="ApplicantData.Username" v-validate="'required'" type="text"
                            class="form-control" name="username" placeholder="Username" />
                        </div>
                        <div v-if="errors.has('username')" class="alert alert-danger" role="alert">Username is required!
                        </div>
                      </div>
                      <div class="form-group mt-20">
                        <div class="input-group">

                          <div class="input-group-prepend">
                            <div class="input-group-text">
                              <font-awesome-icon icon="lock" />
                            </div>
                          </div>


                          <input v-model="ApplicantData.Password" v-validate="'required'" type="password"
                            class="form-control" name="password" placeholder="Password" />
                        </div>

                        <div v-if="errors.has('password')" class="alert alert-danger" role="alert">Password is required!
                        </div>
                      </div>
                      <div class="form-group mt-40">
                        <button class=" btn-block btn btn-outline-secondary" :disabled="loading">
                          <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                          <span>Login</span>
                        </button>
                      </div>
                      <div class="form-group mt-40">
                        <div id="buttonDiv"></div>
                        <div id="g_id_onload"
                              data-client_id="796131519518-i1bsa6n92gb91crb1it5otoj650m2tah.apps.googleusercontent.com"
                              data-context="signin"
                              data-ux_mode="popup"
                              data-callback="handleCredentialResponse"
                              data-auto_prompt="false">
                          </div>

                          <div class="g_id_signin"
                              data-type="standard"
                              data-shape="rectangular"
                              data-theme="outline"
                              data-text="signin_with"
                              data-size="large"
                              data-logo_alignment="left"
                              
                              >
                          </div>
                      </div>
                      
                      <div class=" mt-40"></div>
                      <h5 class="divider">SU</h5>
                      <div class=" mt-40"></div>



                      <div class="form-group">
                        <div v-if="message" class="alert alert-danger" role="alert">{{message}}</div>
                      </div>
                    </form>
                        
                    <!-- <div class="form-group">
                      <button class=" btn-block btn btn-outline-secondary" @click="$router.push('register')">

                        <span>CREATE NEW ACCOUNT</span>
                      </button>
                    </div> -->
                      
                       <!-- <div class="form-group">
                      <b-link class=" " @click="$router.push('ForgetPassword')">

                        <span>Forget Password</span>
                      </b-link>
                    </div> -->
                  </div>
                </div>
              </div>
          </div>
        </div>
      

</div>
</template>

<script>
  import {
    User
  } from '../models/user';
  import {
    ApplicantData
  } from '../models/Applicant'
import ApplicantService from '../services/Applicant/Applicant.service';
window.handleCredentialResponse = (response) => {
 
  //console.log(window.parseJwt(response.credential));
  window.parseJwt(response.credential)
};

window.onload = ()=>{
  google.accounts.id.initialize({
    client_id: '796131519518-i1bsa6n92gb91crb1it5otoj650m2tah.apps.googleusercontent.com',
    callback: window.handleCredentialResponse,
  });
  // eslint-disable-next-line no-undef
  google.accounts.id.renderButton(
    document.getElementById('buttonDiv'),
  // { theme: "outline", size: "large" }  // customization attributes
  );
}
  export default {
    beforeCreate: function() {
        document.body.className = 'home';
        var script =  'https://accounts.google.com/gsi/client'
      let tag = document.createElement("script");
      tag.setAttribute("src", script);
      tag.defer =true
      tag.async =true
      document.head.appendChild(tag);
      
    },
    components: {
    
    },
    name: 'Login',
    data() {
      return {
        user: new User('', ''),
        ApplicantData: new ApplicantData('', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
          '', '', '', '',
          ''),
        loading: false,
        message: '',
        info:'',
        isInit : false ,
        isSignIn :false,
        userEmail : ''
      };
    },
    computed: {
      loggedIn() {
        return this.$store.state.auth.status.loggedIn;
      }
    },
    created() {
    
      if (this.loggedIn) {
        this.$router.push('/NewHome');
      }
      
    },
    mounted(){
 let id = 2;
 ApplicantService.GetHelpPages(id).then(response => {
        this.info = response.data
      });
      window['parseJwt']= (token)=>{
      this.checkLogin(  this.parseJwt(token))
      }
    },
    methods: {
      handleLogin() {
        this.loading = true;
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
            this.loading = false;
            return;
          }
          if (this.ApplicantData.Username && this.ApplicantData.Password) {
               //this.ApplicantData.Username = this.ApplicantData.Username + '@SU' 
            this.$store.dispatch('auth/login', this.ApplicantData).then(
              () => {
                this.$router.push('/NewHome');
              },
              error => {
                this.loading = false;
                this.message =
                  (error.response && error.response.data && error.response.data.Message) ||
                  error.message ||
                  error.toString();
              }
            );
          }
        });
      },
     async handleClickSignIn() {
        
   await   this.$gAuth
        .signIn()
        .then(GoogleUser => {
          //on success do something
          console.log("getBasicProfileEmail", GoogleUser.getBasicProfile());
          let userEmail
          Object.entries(GoogleUser.getBasicProfile()).forEach(([key, value]) => {
              console.log(`${key} ${value}`); // "a 5", "b 7", "c 9"
              if (value.includes('@su.edu.eg')){

                userEmail = value
              }
            });
          if(userEmail){
            // proceed to login
            this.$store.dispatch('auth/ExternalLogin', userEmail).then(
              () => {
                this.$router.push('/NewHome');
              },
              error => {
                this.loading = false;
                this.message =
                  (error.response && error.response.data && error.response.data.Message) ||
                  error.message ||
                  error.toString();
              }
            );
          }else{
           // eslint-disable-next-line no-unused-vars
           const responseT =   this.$gAuth.signOut();
           this.message = "Please use university email to login"
          }
         
          //this.isSignIn = this.$gAuth.isAuthorized;
        })
        .catch(error => {
          //on fail do something
        console.log('error',error)
        });
    },
    checkLogin(user){
      
      if(user.email.includes("@su.edu.eg")){

      
      this.$store.dispatch('auth/ExternalLogin', user.email).then(
              () => {
                this.$router.push('/NewHome');
              },
              error => {
                this.loading = false;
                this.message =
                  (error.response && error.response.data && error.response.data.Message) ||
                  error.message ||
                  error.toString();
              }
            );
      }else{
        alert('Invalid Login attempt')
      }
    },
    parseJwt(token){
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  // eslint-disable-next-line arrow-body-style
  const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
    // eslint-disable-next-line prefer-template
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}
    }
  };
</script>

<style scoped>
.mb-70{
  margin-bottom: 79px;
}
header {
   
    display: none !important;
}
body.home {
  margin: -54px;
}
.toploginHeader{
     background: #285475;
    color: #fff;
    text-align: center;
    border-top: #f00;
    /* margin-top: -37px; */
    position: absolute;
    top: 0px;
    width: 100%;
    left: 0px;
    border-top: 4px solid #ff8d00;
}

  label {
    display: block;
    margin-top: 10px;
  }
.info{
  position: absolute;
    right: 50px;
}
.card-container{
  margin-top: 23%
}
  .card-container.card {
    max-width: 350px !important;
    padding: 40px 40px;
  }

  .card {
    background-color: #f7f7f7;
    padding: 20px 25px 30px;
    margin: 0 auto 25px;
    margin-top: 50px;
    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    border-radius: 2px;
    -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  }

  .profile-img-card {
    width: 96px;
    height: 96px;
    margin: 0 auto 10px;
    display: block;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    border-radius: 50%;
  }

  .panal {
    background: #0000009e;
    border-radius: 10px 10px 0px 0px;
    color: #fff;
    padding: 0px 0px 20px 0px;

  }

  .panal-header {
    background: #FFFFFF;
    color: #285475;
    text-align: center;
    border-radius: 10px 10px 0px 0px;
    padding: 15px;
    font-size: 30px;
    font-weight: bold;
    -moz-box-shadow: inset 0 0 5px #000000;
    -webkit-box-shadow: inset 0 0 5px #000000;
    box-shadow:inset 0 0 5px #000000
  }

  .mt-20 {
    margin-top: 20px;
  }

  .mt-40 {
    margin-top: 40px;
  }

  .form-control {

    color: #ffffff;
    background-color: #9191916b !important;
    background-clip: padding-box;
    border: 1px solid #ced4da75 !important;
  }

  .btn-outline-secondary {
    color: #ffffff;
    border-color: #ffffff;
  }

  .divider {
    font-size: 20px;
    margin: -0.65em auto -0.45em;
    overflow: hidden;
    text-align: center;
    line-height: 1.2em;
  }

  .divider:before,
  .divider:after {
    content: "";
    vertical-align: top;
    display: inline-block;
    width: 50%;
    height: 0.65em;
    border-bottom: 1px solid #fff;
    margin: 0 2% 0 -55%;
  }

  .divider:after {
    margin: 0 -55% 0 2%;
  }


  ::placeholder {
    color: #fff !important;
    opacity: 1;
    /* Firefox */
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #fff !important;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #fff !important;
  }

  .form-control:focus {
    color: #ffffff !important;
  }
  .panal-modal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header-modal{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body-modal{
    padding:20px;
    color:#333;
}
.login-with-google-btn {
  transition: background-color 0.3s, box-shadow 0.3s;
  padding: 12px 16px 12px 42px;
  border: none;
  border-radius: 3px;
  box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.04), 0 1px 1px rgba(0, 0, 0, 0.25);
  color: #757575;
  font-size: 14px;
  font-weight: 500;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTcuNiA5LjJsLS4xLTEuOEg5djMuNGg0LjhDMTMuNiAxMiAxMyAxMyAxMiAxMy42djIuMmgzYTguOCA4LjggMCAwIDAgMi42LTYuNnoiIGZpbGw9IiM0Mjg1RjQiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxwYXRoIGQ9Ik05IDE4YzIuNCAwIDQuNS0uOCA2LTIuMmwtMy0yLjJhNS40IDUuNCAwIDAgMS04LTIuOUgxVjEzYTkgOSAwIDAgMCA4IDV6IiBmaWxsPSIjMzRBODUzIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNNCAxMC43YTUuNCA1LjQgMCAwIDEgMC0zLjRWNUgxYTkgOSAwIDAgMCAwIDhsMy0yLjN6IiBmaWxsPSIjRkJCQzA1IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNOSAzLjZjMS4zIDAgMi41LjQgMy40IDEuM0wxNSAyLjNBOSA5IDAgMCAwIDEgNWwzIDIuNGE1LjQgNS40IDAgMCAxIDUtMy43eiIgZmlsbD0iI0VBNDMzNSIgZmlsbC1ydWxlPSJub256ZXJvIi8+PHBhdGggZD0iTTAgMGgxOHYxOEgweiIvPjwvZz48L3N2Zz4=);
  background-color: white;
  background-repeat: no-repeat;
  background-position: 12px 11px;
}
.login-with-google-btn:hover {
  box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.25);
}
.login-with-google-btn:active {
  background-color: #eeeeee;
}
.login-with-google-btn:focus {
  outline: none;
  box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.25), 0 0 0 3px #c8dafc;
}
.login-with-google-btn:disabled {
  filter: grayscale(100%);
  background-color: #ebebeb;
  box-shadow: 0 -1px 0 rgba(0, 0, 0, 0.04), 0 1px 1px rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}




  @import url('../assets/style.css');

</style>